module.exports = __webpack_public_path__ + "static/img/al2.e13c969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al2.jpg
// module id = 9nbD
// module chunks = 1